import * as React from 'react';
const { useState, useCallback } = React;

import IconButton from '../icon-button';
import Icon from '../icon';
import {
	Root,
	Header,
	ButtonLayout,
	ContentLayout,
	IconLayout,
} from './styled';


export type FoldingItemProps = {
	renderHeader?: () => React.ReactNode;
};

const FoldingItem: React.SFC<FoldingItemProps> = (props) => {
	const {
		renderHeader,
		children,
		...rest
	} = props;
	const [isOpen, setIsOpen] = useState(true);
	const handleClick = useCallback(() => setIsOpen(v => !v), []);

	return (
		<Root {...rest}>
			<Header onClick={handleClick}>
				<ButtonLayout>
					<IconButton>
						<IconLayout isOpen={isOpen}>
							<Icon type='expand-more' color='muted' width={24} height={24} />
						</IconLayout>
					</IconButton>
				</ButtonLayout>
				{typeof renderHeader === 'function' && renderHeader()}
			</Header>
			{
				isOpen &&
				<ContentLayout>
					{children}
				</ContentLayout>
			}
		</Root>
	);
}

FoldingItem.displayName = 'FoldingItem';
FoldingItem.defaultProps = {};

export default FoldingItem;
